import { render, staticRenderFns } from "./MiddleMobile.vue?vue&type=template&id=35aa6fe0&scoped=true"
import script from "./MiddleMobile.vue?vue&type=script&lang=js"
export * from "./MiddleMobile.vue?vue&type=script&lang=js"
import style0 from "./MiddleMobile.vue?vue&type=style&index=0&id=35aa6fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aa6fe0",
  null
  
)

export default component.exports